module.exports = __webpack_public_path__ + "static/media/partners.0c7af318.jpg";